module.exports = __webpack_public_path__ + "img/fushimi-HP-QR.e13a6b6f.png";